import { FC } from 'react';
import AcessoriesDesktop from './AcessoriesDesktop/AcessoriesDesktop';
import AcessoriesMobile from './AcessoriesMobile/AcessoriesMobile';
import { AccessoriesScreenContainer } from 'app/hooks/useAccessoriesScreenState';
import { AccessoriesProps } from './Components/AccessoriesForm';
import { isMobile } from 'utils/isMobile';
import useScrollTop from 'app/hooks/useScrollTop';
import useGetAllResorts from 'app/hooks/useGetAllResorts';

const Accessories: FC<AccessoriesProps> = props => {
  useScrollTop(true);
  useGetAllResorts({ forceRefetch: true });

  return (
    <>
      <AccessoriesScreenContainer.Provider>
        {isMobile ? (
          <AcessoriesMobile
            onConfirm={props?.onConfirm}
            onCancel={props?.onCancel}
            isEdit={props.isEdit}
          />
        ) : (
          <AcessoriesDesktop {...props} />
        )}
      </AccessoriesScreenContainer.Provider>
    </>
  );
};

export default Accessories;
